import { useEffect, useState } from 'react';
import AvatarLightbox from './AvatarLightbox';
import { IOpenAvatarLightboxDetail } from './openAvatarLightbox';

function GlobalAvatarLightbox() {
  const [state, setState] = useState<IOpenAvatarLightboxDetail | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<IOpenAvatarLightboxDetail>).detail;
      if (detail?.userName) setState(detail);
    };
    window.addEventListener('openAvatarLightbox', handler);
    return () => window.removeEventListener('openAvatarLightbox', handler);
  }, []);

  if (!state) return null;
  return (
    <AvatarLightbox
      open
      userName={state.userName}
      initialAvatarUrl={state.avatarUrl ?? null}
      onClose={() => setState(null)}
    />
  );
}

export default GlobalAvatarLightbox;
